/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Negotiation_Error_Load_TemplatesInputs */

const en_negotiation_error_load_templates = /** @type {(inputs: Negotiation_Error_Load_TemplatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to load negotiation templates.`)
};

const de_negotiation_error_load_templates = /** @type {(inputs: Negotiation_Error_Load_TemplatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to load negotiation templates.`)
};

const fr_negotiation_error_load_templates = /** @type {(inputs: Negotiation_Error_Load_TemplatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to load negotiation templates.`)
};

const es_negotiation_error_load_templates = /** @type {(inputs: Negotiation_Error_Load_TemplatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to load negotiation templates.`)
};

const it_negotiation_error_load_templates = /** @type {(inputs: Negotiation_Error_Load_TemplatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to load negotiation templates.`)
};

const nl_negotiation_error_load_templates = /** @type {(inputs: Negotiation_Error_Load_TemplatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to load negotiation templates.`)
};

const pl_negotiation_error_load_templates = /** @type {(inputs: Negotiation_Error_Load_TemplatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to load negotiation templates.`)
};

const fi_negotiation_error_load_templates = /** @type {(inputs: Negotiation_Error_Load_TemplatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to load negotiation templates.`)
};

const da_negotiation_error_load_templates = /** @type {(inputs: Negotiation_Error_Load_TemplatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to load negotiation templates.`)
};

const sv_negotiation_error_load_templates = /** @type {(inputs: Negotiation_Error_Load_TemplatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to load negotiation templates.`)
};

/**
* | output |
* | --- |
* | "Failed to load negotiation templates." |
*
* @param {Negotiation_Error_Load_TemplatesInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const negotiation_error_load_templates = /** @type {((inputs?: Negotiation_Error_Load_TemplatesInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Negotiation_Error_Load_TemplatesInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_negotiation_error_load_templates(inputs)
	if (locale === "fr") return fr_negotiation_error_load_templates(inputs)
	if (locale === "es") return es_negotiation_error_load_templates(inputs)
	if (locale === "it") return it_negotiation_error_load_templates(inputs)
	if (locale === "nl") return nl_negotiation_error_load_templates(inputs)
	if (locale === "pl") return pl_negotiation_error_load_templates(inputs)
	if (locale === "fi") return fi_negotiation_error_load_templates(inputs)
	if (locale === "da") return da_negotiation_error_load_templates(inputs)
	if (locale === "sv") return sv_negotiation_error_load_templates(inputs)
	return en_negotiation_error_load_templates(inputs)
});